/**
 * Shared types for the Notes view block components.
 * Prop shape flows: RequirementsNotes → NotesChapter → NotesNode → {Initiative|Epic|Story}.
 */
import type { Requirement, RequirementTheme } from '@ispot/shared'
import type { useBlockReorder } from '@/hooks/useBlockReorder'
import type { CreateBlockInput } from '../AdderBlock'
import type { BlockType } from '../SlashMenu'

export type Dnd = ReturnType<typeof useBlockReorder>

export interface PersonaMeta { name: string; role?: string; color?: string; initials?: string; photo?: string }

export interface NotesSharedProps {
  onUpdate: (id: string, updates: Partial<Requirement>) => Promise<unknown>
  onCreate: (input: CreateBlockInput) => Promise<{ id: string }>
  onDelete: (id: string) => Promise<void>
  insertAfter: (anchor: Requirement, newType: BlockType, personaSessionId?: string) => Promise<{ id: string }>
  dnd: Dnd
  personaSessionId?: string
  personaIndex?: Map<string, PersonaMeta>
  themes: RequirementTheme[]
}

/** Group IDs are "p:<personaSessionId>" for persona groups. */
export function extractPersonaFromGroupId(id: string): string | undefined {
  if (id.startsWith('p:')) return id.slice(2)
  return undefined
}
